var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`flag-icon flag-icon-${_vm.code.toLowerCase()}`,attrs:{"alt":_vm.regionName(_vm.code),"title":_vm.regionName(_vm.code)}})
}
var staticRenderFns = []

export { render, staticRenderFns }